import { lockScroll } from "../../@helpers/js/scrollLocker.js";

import ClassNames from "./classNames.js";
import DomElements from "./domElements.js";
const { $overlay } = DomElements;
import Shared from "./shared.js";
const {
  isMobileMenuOpen,
  closeAllSubmenus,
  isAnySubmenuOpen,
} = Shared;
import { interpretAction } from "../../@helpers/js/interpretAction.js";

/**
 * Handle initial setup
 */
function initOverlay() {
  $overlay?.addEventListener("click", () => {
    if (isAnySubmenuOpen()) closeAllSubmenus();
    toggle("close");
    toggleScrollLock(false);
  });
}

/**
 * Reevaluate if overflow should be opened or closed
 */
function reevaluateOverlay() {
  if (!isOpen()) {
    if (isAnySubmenuOpen() || isMobileMenuOpen()) {
      toggle("open");
      toggleScrollLock(true);
    }
  } else {
    if (
      (!isAnySubmenuOpen() &&
        window.innerWidth >= 768) ||
      (!isMobileMenuOpen() && window.innerWidth < 768)
    ) {
      toggle("close");
      toggleScrollLock(false);
    }
  }
}

/**
 * Check if open
 *
 * @returns If open
 */
const isOpen = () => !!$overlay?.classList?.contains(
  `${ClassNames.overlay}--${ClassNames.modifiers.active}`
);

/**
 * Toggle visibility
 */
const toggle = (action) => {
  $overlay.classList[interpretAction(action)](
    `${ClassNames.overlay}--${ClassNames.modifiers.active}`
  );
};

/**
 *  Only lock scrollbar if there is no visible scrollbar (mobile).
 *  Locking can cause content shift otherwise
 */
function toggleScrollLock(lock) {
  const scrollbarWidth =
    window.innerWidth - document.documentElement.offsetWidth;
  if (scrollbarWidth && lock) return;

  lockScroll(lock, "instant");
}

export default {
  initOverlay,
  reevaluateOverlay,
};
